module.exports = __webpack_public_path__ + "img/bud-wow.fc490e12.png";